import { render, staticRenderFns } from "./StepMapColumns.vue?vue&type=template&id=228895c6"
import script from "./StepMapColumns.vue?vue&type=script&lang=js"
export * from "./StepMapColumns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports